<template>
  <div>
    <div id="update-alert">
      <a v-on:click="reload">Nouvelle version de l'application disponible. Cliquez ici pour la télécharger.</a>
    </div>
    <v-navigation-drawer temporary v-model="drawer" light overflow absolute>
      <v-list class="pt-0" two-line>

        <v-list-tile disabled>
          <v-list-tile-action>
            <v-icon>dashboard</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title> <span v-if="tabletName">{{ tabletName }}</span></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-on:click.native="drawer=false;connectionDialog = true">
          <v-list-tile-action>
            <v-icon>tablet_android</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span v-if="!tabletId || !token || authenticated === false"> Tablette non authentifiée</span>
              <span v-else>Tablette authentifiée</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-on:click.native="update">
          <v-list-tile-action>
            <span v-if="(stagedAnswers.length > 0 || dataExpired) && !isUpdating"> <v-icon>warning</v-icon></span>
            <span class="loading-rotate" v-else-if="isUpdating"><v-icon>cached</v-icon></span>
            <span v-else> <v-icon>check_circle</v-icon></span>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Status:
              <strong v-if="online">connecté</strong>
              <strong v-else>hors connexion</strong>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              <span v-if="(stagedAnswers.length > 0 || dataExpired) && !isUpdating">Mises à jours nécessaires.</span>
              <span v-else-if="isUpdating">Mise à jour en cours...</span>
              <span v-else-if="online">Données à jour</span>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>
        <v-list-tile v-on:click.native="toggleShowMoreInMenu()">
          <v-list-tile-content>
            <v-list-tile-title v-if="showMoreInMenu">Réduire</v-list-tile-title>
            <v-list-tile-title v-else>Avancé</v-list-tile-title>
            <v-list-tile-sub-title>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon v-if="showMoreInMenu">keyboard_arrow_up</v-icon>
            <v-icon v-else>keyboard_arrow_down</v-icon>
          </v-list-tile-action>
        </v-list-tile>

        <template v-if="showMoreInMenu">
          <v-divider></v-divider>
          <v-list-tile :disabled="!online" v-on:click.native="sendDiag()">
            <v-list-tile-action>
              <v-icon>bug_report</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Envoyer un rapport
              </v-list-tile-title>
              <v-list-tile-sub-title>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :disabled="!online" v-on:click.native="reloadApp()">
            <v-list-tile-action>
              <v-icon>refresh</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Rafraichir l'application
              </v-list-tile-title>
              <v-list-tile-sub-title>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-on:click.native="goToAdmin()">
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                Administration
              </v-list-tile-title>
              <v-list-tile-sub-title>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <v-list-tile disabled style="position: absolute; bottom: 0;">
          <v-list-tile-content>
            Version : {{ version }}
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar fixed class="blue top-toolbar" dark>
      <v-toolbar-side-icon @click.native.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Weview</v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-if="(stagedAnswers.length > 0 || dataExpired) && !isUpdating">Mises à jours nécessaires.</span>
      <span v-else-if="isUpdating">Mise à jour en cours...</span>
      <span v-else-if="!online">Hors ligne</span>
      <v-btn icon v-on:click.native="update">
        <span v-if="(stagedAnswers.length > 0 || dataExpired) && !isUpdating"> <v-icon>warning</v-icon></span>
        <span class="loading-rotate" v-else-if="isUpdating"><v-icon>cached</v-icon></span>
        <span v-else-if="!online"><v-icon>remove_circle</v-icon></span>
        <span v-else> <v-icon>check_circle</v-icon></span>
      </v-btn>
    </v-toolbar>

    <v-dialog v-model="confirmSendDiag" persistent scrollable width="480">
      <v-card>
        <v-card-title>
          <div class="headline">Envoyer un rapport</div>
        </v-card-title>
        <v-card-text>
          Êtes-vous sûr de vouloir envoyer un rapport aux équipes Weview ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat v-on:click.native="confirmSendDiag = false" v-if="!isSendingDiag">Non</v-btn>
          <v-btn primary color="accent" v-on:click.native="processSendDiag()" :loading="isSendingDiag">Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container class="home pt-4">
      <v-layout row>
        <v-flex xs12 sm12 md6 offset-md3>
          <template v-if="!token || !tabletId || authenticated === false">
            <v-alert class="mb-4" value="true" error>
              Cette tablette n'est pas authentifiée
            </v-alert>
            <v-btn primary large class="blue" v-on:click.native="connectionDialog = true">Connecter la tablette</v-btn>
          </template>
          <div v-else-if="dataExpired">
            <v-alert class="mb-4" value="true" error>Les données de cette tablette ont expiré. Merci de connecter cette tablette à internet et/ou de retrouver du réseau afin de les mettre à jour</v-alert>
          </div>
          <div class="loading text-xs-center" v-else-if="dataExpired && isUpdating">
            <h4 class="pb-4 pt-4">Données en cours de synchronisation...</h4>
            <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" class="primary--text"></v-progress-circular>
          </div>
          <navigation :currentMenu="item" v-else></navigation>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="connectionDialog" persistent scrollable width="480">
      <v-card>
        <v-card-title>
          <div class="headline">Quel est le code de connexion de cette tablette ?</div>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Code de connexion" v-model="connectionCode"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn secondary v-on:click.native="connectionDialog = false">Annuler</v-btn>
          <v-btn primary v-on:click.native="connect">Connexion</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Navigation from './Navigation';
import { mapState } from 'vuex';

export default {
  name  : `home`,
  props : [`company`, `item`],
  data () {
    return {
      connectionCode   : ``,
      drawer          : null,
      connectionDialog : null,
      showMoreInMenu : false,
      confirmSendDiag : false,
      isSendingDiag : false,
    };
  },
  beforeRouteUpdate (to, from, next) {
    // ne pas aller vers la selection du diag ou du participant si on pas les données pour
    if (to.path === `/choose/survey` && !this.$store.state.navigation.currentManager) {
      return;
    } else if (to.path === `/choose/participant` && (!this.$store.state.navigation.currentManager || !this.$store.state.navigation.currentSurveyStart)) {
      return;
    }
    next();
  },
  components : { Navigation },
  computed   : {
    tabletName () {
      if (this.$store.state.weviewObject && this.$store.state.weviewObject.tabletName) {
        return this.$store.state.weviewObject.tabletName;
      }

      return ``;
    },
    ...mapState([`isUpdating`, `token`, `tabletId`, `dataExpired`, `online`, `stagedAnswers`, `isUpdating`, `authenticated`]),
    version: () => process.env.VERSION,
  },
  methods: {
    connect () {
      this.$store.dispatch(`connect`, this.connectionCode);
      this.connectionDialog = false;
    },
    update () {
      this.$store.dispatch(`updateAll`, true);
    },
    goToAdmin () {
      this.$router.push({ name : `Admin` });
    },
    reload () {
      document.location.reload(true);
    },
    sendDiag () {
      if (this.isSendingDiag || !this.online) { return; }
      this.drawer = false;
      this.confirmSendDiag = true;
    },
    async processSendDiag () {
      this.isSendingDiag = true;
      await this.$store.dispatch(`sendDiag`);
      this.confirmSendDiag = false;
      setTimeout(() => {
        this.isSendingDiag = false;
      }, 250);
    },
    reloadApp () {
      if (!this.online) { return; }
      this.$router.push({ name : `Root` });
      setTimeout(() => document.location.reload(true));
    },
    toggleShowMoreInMenu () {
      this.showMoreInMenu = !this.showMoreInMenu;
    },
  },
  watch : {
    drawer () {
      if (!this.drawer) { this.showMoreInMenu = false; }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only  -->
<style scoped>
.menu {
  position      : absolute;
  top           : 0;
  left          : 0;
  margin        : 1rem;
  padding       : 5px;
  border        : 2px solid #555;
  border-radius : 4px;
}

.menu > i.icon {
  font-size: 2.1rem;
}

@keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(359deg);
    }
}

.loading-rotate {
  -webkit-animation: rotation 2s infinite linear;
}
</style>

<style>
  .update-available #app.online .top-toolbar {
    top: 50px;
  }
</style>



// WEBPACK FOOTER //
// Home.vue?2c0d7e1a